<script lang="ts">
  import Skeleton from "./ui/Skeleton.svelte";
  import Card from "./ui/Card.svelte";
  import CardContent from "./ui/CardContent.svelte";
  import CardHeader from "./ui/CardHeader.svelte";
</script>

<div class="mx-auto max-w-2xl px-5 pb-12 pt-6">
  <header class="mb-5 flex items-center justify-between">
    <Skeleton class="h-5 w-32" />
    <Skeleton class="h-7 w-20" />
  </header>

  <Card class="mb-5 border-2">
    <CardHeader class="pb-3">
      <div class="flex items-center justify-between">
        <Skeleton class="h-4 w-32" />
        <Skeleton class="h-3 w-24" />
      </div>
    </CardHeader>
    <CardContent class="space-y-3">
      <div class="flex items-start gap-4">
        <Skeleton class="h-16 w-24 shrink-0" />
        <div class="flex-1 space-y-2">
          <Skeleton class="h-8 w-2/3" />
          <Skeleton class="h-3 w-1/2" />
        </div>
      </div>
      <Skeleton class="h-4 w-3/4" />
      <Skeleton class="h-3 w-1/2" />
      <Skeleton class="h-7 w-32" />
      <div class="border-t border-dashed pt-4 space-y-2">
        <Skeleton class="h-3 w-32" />
        <Skeleton class="h-5 w-full" />
        <Skeleton class="h-5 w-5/6" />
      </div>
    </CardContent>
  </Card>

  <div class="space-y-2.5">
    {#each Array(4) as _}
      <Card>
        <div class="flex items-center gap-3 px-5 py-4">
          <Skeleton class="h-5 w-5 rounded-full" />
          <Skeleton class="h-4 w-20" />
          <div class="flex-1"></div>
          <Skeleton class="h-4 w-16" />
          <Skeleton class="h-4 w-12" />
        </div>
      </Card>
    {/each}
  </div>
</div>
